import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, vShow as _vShow, vModelCheckbox as _vModelCheckbox } from "vue"
import _imports_0 from '@/assets/images/icons/travel-calendar-1.svg'
import _imports_1 from '@/assets/images/icons/travel-destination-2.svg'
import _imports_2 from '@/assets/images/icons/whatsapp-checkout-1.svg'
import _imports_3 from '@/assets/images/icons/mail-checkout-1.svg'


const _hoisted_1 = {
  key: 0,
  class: "checkout page-content"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "checkout-container main-container" }
const _hoisted_4 = { class: "checkout_row" }
const _hoisted_5 = { class: "page-title plain" }
const _hoisted_6 = { class: "mb-0" }
const _hoisted_7 = { class: "checkout-block checkout-page-block travel-checkout" }
const _hoisted_8 = { class: "checkout-top" }
const _hoisted_9 = { class: "checkout-top__block" }
const _hoisted_10 = { class: "result-listing__item__block_top_row row align-items-center" }
const _hoisted_11 = { class: "partner-logo col-lg-3 col-md-12" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "partner-content col-lg-7 col-md-12" }
const _hoisted_14 = { class: "partner-content_title" }
const _hoisted_15 = { class: "mb-0" }
const _hoisted_16 = { class: "partner-content_bottom d-flex mb-4 row flex-nowrap policy-details-checkout" }
const _hoisted_17 = { class: "partner-content_bottom_item col-md-6 flex-nowrap me-0" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "img-fluid"
  })
], -1)
const _hoisted_19 = { class: "title" }
const _hoisted_20 = { class: "text mw-100" }
const _hoisted_21 = { class: "partner-content_bottom_item col-md-6 flex-nowrap me-0" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "img-fluid"
  })
], -1)
const _hoisted_23 = { class: "title align-items-start" }
const _hoisted_24 = { class: "tooltip-content" }
const _hoisted_25 = { class: "partner-content_bottom_item cover-cost-block row flex-wrap" }
const _hoisted_26 = {
  key: 0,
  class: "col-lg-4 col-md-6 me-0"
}
const _hoisted_27 = { class: "right-buy-now text-center h-100 col-lg-2 col-md-12 pt-0 border-0 traveller_right_block" }
const _hoisted_28 = { class: "right-buy-now-top" }
const _hoisted_29 = { class: "premium_block" }
const _hoisted_30 = { class: "premium-title d-flex align-items-center justify-content-center" }
const _hoisted_31 = {
  key: 0,
  class: "label-block_question position-relative"
}
const _hoisted_32 = { class: "tooltip-content" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("a", {
  class: "popper",
  "data-bs-trigger": "hover",
  placement: "right",
  "data-bs-toggle": "popover"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "icon-info-new" })
  ])
], -1)
const _hoisted_35 = { class: "price-title" }
const _hoisted_36 = { class: "mb-0" }
const _hoisted_37 = { class: "traveller_block" }
const _hoisted_38 = { class: "no_of_traveller" }
const _hoisted_39 = {
  key: 0,
  class: "share-icons"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-0" }, "Share", -1)
const _hoisted_41 = { class: "p-0 d-flex align-items-center justify-content-center" }
const _hoisted_42 = { class: "icon" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "whatsapp"
}, null, -1)
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "email"
}, null, -1)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = {
  key: 0,
  role: "alert",
  "aria-live": "assertive",
  "aria-atomic": "true",
  class: "toast custom-toast success-toast show",
  "data-bs-autohide": "false"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "toast-body" }, " Email sent successfully! ", -1)
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = { class: "checkout-middle" }
const _hoisted_51 = { class: "partner-content_bottom row w-100" }
const _hoisted_52 = {
  key: 0,
  class: "partner-content_bottom_item col-lg-3 col-md-6 col-sm-12 me-0"
}
const _hoisted_53 = { class: "checkout-middle-footer" }
const _hoisted_54 = { class: "result-listing__item__block middle-footer-checkout" }
const _hoisted_55 = { class: "result-listing__item__block-bottom-top pb-0" }
const _hoisted_56 = {
  class: "summary m-0 p-0",
  style: {"box-shadow":"none"}
}
const _hoisted_57 = { class: "inner-title" }
const _hoisted_58 = { class: "mb-0" }
const _hoisted_59 = { class: "row" }
const _hoisted_60 = {
  key: 0,
  class: "col-lg-3 col-md-6 col-sm-6 special-features"
}
const _hoisted_61 = { class: "listing-ul" }
const _hoisted_62 = { style: {"margin-bottom":"0.5rem"} }
const _hoisted_63 = { class: "mw-100" }
const _hoisted_64 = {
  key: 0,
  class: "checkout-block-details checkout-bloc-custom"
}
const _hoisted_65 = /*#__PURE__*/_createElementVNode("span", { class: "icon-dropdown-down" }, null, -1)
const _hoisted_66 = { class: "checkout-bottom checkout-bottom-container" }
const _hoisted_67 = { class: "checkout-block-traveller-details" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("h4", { class: "mb-0" }, "Traveller details", -1)
const _hoisted_69 = {
  key: 0,
  class: "row item-row"
}
const _hoisted_70 = { class: "mb-0" }
const _hoisted_71 = {
  key: 0,
  class: "vechile-details-list"
}
const _hoisted_72 = { class: "row form-block travel-date" }
const _hoisted_73 = { class: "col-lg-3 col-md-6 col-sm-6" }
const _hoisted_74 = { class: "col-lg-3 col-md-6 col-sm-6" }
const _hoisted_75 = { class: "col-lg-3 col-md-6 col-sm-6" }
const _hoisted_76 = { class: "col-lg-3 col-md-6 col-sm-6" }
const _hoisted_77 = { class: "row form-block travel-date" }
const _hoisted_78 = { class: "col-lg-3 col-md-6 col-sm-6" }
const _hoisted_79 = {
  key: 0,
  class: "col-lg-3 col-md-6 col-sm-6"
}
const _hoisted_80 = {
  key: 1,
  class: "col-lg-3 col-md-6 col-sm-6"
}
const _hoisted_81 = {
  key: 2,
  class: "col-lg-3 col-md-6 col-sm-6"
}
const _hoisted_82 = {
  key: 3,
  class: "col-lg-3 col-md-6 col-sm-6"
}
const _hoisted_83 = {
  key: 4,
  class: "col-lg-3 col-md-6 col-sm-6"
}
const _hoisted_84 = { class: "checkout-bottom_block" }
const _hoisted_85 = { class: "row" }
const _hoisted_86 = { class: "col-md-8 left-col" }
const _hoisted_87 = { class: "checkout-left-row-block" }
const _hoisted_88 = { class: "checkout-left-row" }
const _hoisted_89 = { class: "disclaimer-block" }
const _hoisted_90 = { class: "coupon-block-container" }
const _hoisted_91 = { class: "coupon-block" }
const _hoisted_92 = { class: "coupon-block-form" }
const _hoisted_93 = ["placeholder"]
const _hoisted_94 = ["onClick", "value"]
const _hoisted_95 = ["onClick", "value"]
const _hoisted_96 = {
  key: 0,
  class: "error"
}
const _hoisted_97 = { class: "col-md-4 right-col" }
const _hoisted_98 = { class: "summary" }
const _hoisted_99 = { class: "inner-title d-flex align-items-center" }
const _hoisted_100 = { class: "mb-0" }
const _hoisted_101 = {
  key: 0,
  class: "label-block_question position-relative"
}
const _hoisted_102 = { class: "tooltip-content" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_104 = /*#__PURE__*/_createElementVNode("a", {
  class: "popper",
  "data-bs-trigger": "hover",
  placement: "right",
  "data-bs-toggle": "popover"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "icon-info-new" })
  ])
], -1)
const _hoisted_105 = { class: "summary-block" }
const _hoisted_106 = { class: "summary-block__table" }
const _hoisted_107 = { class: "summary-block__table--item" }
const _hoisted_108 = { class: "left" }
const _hoisted_109 = { class: "right" }
const _hoisted_110 = { class: "left" }
const _hoisted_111 = { class: "right" }
const _hoisted_112 = {
  key: 1,
  class: "summary-block__table--item"
}
const _hoisted_113 = { class: "left" }
const _hoisted_114 = { class: "right" }
const _hoisted_115 = {
  key: 2,
  class: "summary-block__table--item"
}
const _hoisted_116 = { class: "left" }
const _hoisted_117 = { class: "right" }
const _hoisted_118 = {
  key: 3,
  class: "summary-block__table--item"
}
const _hoisted_119 = { class: "left" }
const _hoisted_120 = {
  class: "right",
  dir: "ltr"
}
const _hoisted_121 = { class: "summary-block__table--item" }
const _hoisted_122 = { class: "left" }
const _hoisted_123 = { class: "right big-bold" }
const _hoisted_124 = {
  key: 0,
  class: "agree-terms-conditions"
}
const _hoisted_125 = { class: "agree-terms-conditions-checkbox" }
const _hoisted_126 = { for: "add-to-compare1" }
const _hoisted_127 = {
  href: "javascript::void(0)",
  style: {"cursor":"default"}
}
const _hoisted_128 = {
  key: 1,
  class: "checkout-button"
}
const _hoisted_129 = ["disabled"]
const _hoisted_130 = { class: "text-center" }
const _hoisted_131 = { class: "vechile-list page-content" }
const _hoisted_132 = { class: "container" }
const _hoisted_133 = { class: "vechile-list-container main-container" }
const _hoisted_134 = { class: "vechile-list_row" }
const _hoisted_135 = { class: "row justify-content-center" }
const _hoisted_136 = { class: "col-md-6" }

import { computed, onMounted, ref } from "vue";
  import { store } from "@/store";
  import Quotes from "@/core/services/Quotes";
  import reviewService from "@/core/services/ReviewDetails";
  import personalService from "@/core/services/PersonalDetails";
  import Checkouts from "@/core/services/Checkouts";
  import { useReCaptcha } from "vue-recaptcha-v3";
  import Insurances from "@/core/services/Insurances";
  import Countries from "@/core/services/Countries";
  import { getTextWidth, setDateMdY } from '@/store/stateless/globalVar'
  import router from "@/router";
  import Coupons from "@/core/services/Coupons";


  
export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutDetails',
  setup(__props) {

  const domain = ref(process.env.VUE_APP_ASSETS_DOMAIN);
  const url = ref(process.env.VUE_APP_INSURANCE_ASSETS_URL);

  const isOrient = ref(process.env.VUE_APP_ORIENT_INSURANCE_ID);
  const isIsa = ref(process.env.VUE_APP_ISA_INSURANCE_ID);
  const isGts = ref(process.env.VUE_APP_GTS_INSURANCE_ID);

  const readMore = ref(false);
  const captcha = useReCaptcha();
  const loading = ref(false)

  const coupon = ref();

  const customer = computed(() => {
    return store.state.personals.customer;
  });

  const quote: any = computed(() => {
    return store.state.review.review_details;
  });

  const totalPremium = ref(0);
  const isAccept = ref(true);
  const isSent = ref(false);

  const vatper = computed(() => {
    return store.state.quotes.vat;
  });

  const stampFee = computed(() => {
    return store.state.quotes.stampFee;
  });

  const whatsappContent = computed(() => {
    return store.state.quotes.whatapp_template;
  });

  const language = computed(() => {
    return window.localStorage.getItem("language");
  });

  const agent = computed(() => {
    return router.currentRoute.value.query ? router.currentRoute.value.query.agent_id : null;
  });

  
  const discount = computed(() => {
    let disc = 0;
    let coupon = store.state.coupon.success;
    if (coupon) {
      disc = coupon.data.discount_amount || 0;
    }
    return disc;
  });

  const isHundredPercent = computed(() => {
    let coupon = store.state.coupon.success;
    if(coupon) {
      return coupon.data.discount_type_id === 1 && Number(coupon.data.discount_value) >= 100
    }
    return false
  })

  const vat = ref(0)
  const calculateTotalPremium = () => {
    totalPremium.value = parseFloat(quote.value?.invoice?.total_price_vat) - parseFloat(discount.value);
    if(parseFloat(discount.value) > 0) {
      vat.value = totalPremium.value * (parseInt(vatper.value) / 100)
    } else {
      vat.value = calculateVat()
    }

    if(isHundredPercent.value) {
      const addons = quote.value.invoice && quote.value.invoice.policy_addons ? quote.value.invoice.policy_addons.map(addon => Number(addon.addon_price)) : []
      const sumOfaddons = addons.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
      totalPremium.value = 0 + sumOfaddons
      vat.value = totalPremium.value * (parseInt(vatper.value) / 100)

      totalPremium.value += vat.value
    }
    
      // parseFloat(quote.value?.invoice?.total_price_without_vat) + vat.value;
  };

  const calculateVat = () => {
    if (parseInt(vatper.value) > 0) {
      if(quote.value.invoice?.insurance_provider_id == isIsa.value) {
        return parseFloat(quote.value.invoice?.vat);
      } else {
        return parseFloat(quote.value.invoice?.total_price_without_vat) * (parseInt(vatper.value) / 100);
      }
    }
    return 0;
  }

  const is_thank_you = computed(() => {
    const thankyou = window.localStorage.getItem('thankyou')
    if(thankyou)
      return true

    return false
  })

  // const calculateTotalPremium = () => {
  //   totalPremium.value = parseFloat(quote.value?.invoice?.total_price_vat) - parseFloat(discount.value);
  //     // parseFloat(quote.value?.invoice?.total_price_without_vat) + vat.value;
  // };

  const showForAll = computed(()=>{
    return showForManualPlans.value || showForIsa.value || showForGts.value;
  });

  const showForManualPlans = computed(()=>{
    return quote?.value?.invoice && (quote?.value?.invoice?.is_api_plan == false)
  });

  const showForIsa = computed(()=>{
    return (quote?.value?.invoice && (parseInt(quote?.value?.invoice?.insurance_provider_id) == parseInt(isIsa.value)))
  });

  const showForGts = computed(()=>{
    return (quote?.value?.invoice && (parseInt(quote?.value?.invoice?.insurance_provider_id) == parseInt(isGts.value)))
  });

  onMounted(async () => {
    loading.value = true

    if(is_thank_you.value)
      router.push({name: 'TravellerDetails'})

    window.localStorage.setItem("is_edit", "1");
    await Countries.getCountries();
    await Quotes.getVat();
    await Insurances.getInsuredTypes();

    window.localStorage.setItem("traveller_index", JSON.stringify(0));

    console.log({'mix':'mix'});

    const uuid = router.currentRoute.value.query ? router.currentRoute.value.query.uuid : null;
      let channel = router.currentRoute.value.query ? router.currentRoute.value.query.channel : null;  
    const agent = router.currentRoute.value.query && router.currentRoute.value.query.agent_id ? router.currentRoute.value.query.agent_id : null;
    if (uuid) {
      const payload = {
        uuid: uuid,
        agent_id:agent,
        link: window.location.origin + window.location.pathname + "?lang=en&uuid=" + uuid,
        pagename: 'checkout-detail'
      };
      await reviewService.getDetailsCheckout(payload);
      await personalService.getDetails({ uuid:uuid, channel });
    }
    loading.value = false
    calculateTotalPremium();
  });

  const sentLinkToCustomer = async (buttonType, pageName) => {
    if (buttonType == 'whatsapp') {
      const url = `https://api.whatsapp.com/send?phone=${customer.value?.complete_phone_number}&text=${encodeURIComponent(whatsappContent.value)}`
      window.open(url)
    }
    if (buttonType == 'email') {
      const uuid = router.currentRoute.value.query ? router.currentRoute.value.query.uuid : null;
      const agent = router.currentRoute.value.query ? router.currentRoute.value.query.agent_id : null;
      const payload = {
        uuid: uuid,
        pagename: pageName,
        agent_id:agent,
        link: window.location.origin + window.location.pathname + "?lang=en&uuid=" + uuid
      }
      await Quotes.sendEmail(payload);
      isSent.value = true;
      setTimeout(() => {
        isSent.value = false;
      }, 5000)
    }
  }

  const omt = computed(() => {
        return router.currentRoute.value.query && router.currentRoute.value.query.channel ? router.currentRoute.value.query.channel : null;
    })

  const proceedClick = async () => {
    if(!couponSuccess.value) coupon.value = ''
    // load captcha
    await captcha?.recaptchaLoaded();
    // execute reCaptcha
    const token = await captcha?.executeRecaptcha("login");
    if (token) {
      loading.value = true
      const uuid = router.currentRoute.value.query ? router.currentRoute.value.query.uuid : null;
      const sessionId = window.localStorage.getItem('session_id');
      if (uuid) {
        const payload = {
          merchant_reference: quote.value?.invoice?.quote_ref_no,
          uuid: uuid,
          language: language.value,
          vat: vat.value,
          stamp_fee: stampFee.value,
          total_price_vat: parseFloat(totalPremium.value) + parseFloat(discount.value),
          url: process.env.VUE_APP_PAYMENT_GATEWAY_URL + `/` + language.value,
          session_id: sessionId ?? '',
          coupon: coupon.value,
          is_hundred_percent: isHundredPercent.value,
          channel: omt.value
        };
        // console.log(payload)
        await Checkouts.postCheckout(payload);
        setTimeout(() => {
          loading.value = false
        }, 2500);
      }
    }
  };

  const addDash = (value) => {
    return value ? value : '-'
  }

  const couponError = computed(() => {
    return store.state.coupon.error;
  });

  const couponSuccess = computed(() => {
    return store.state.coupon.success;
  });

  // submit event
  const couponCode = async() => {
      await Coupons.postCoupon({
        promo_code: coupon.value,
        merchant_reference: quote.value?.invoice?.quote_ref_no,
        language:language.value,
        insurance_type:'travel'
    });
    calculateTotalPremium()
  };

  const couponRemove = () => {
    coupon.value = '';
    Coupons.removeCoupon();
    calculateTotalPremium()
  };

  const trimSpaces = ()=>{
    coupon.value = coupon.value.replace(/\s+/g, '');
  }



return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_h_page_loader = _resolveComponent("h-page-loader")!

  return (quote.value && quote.value?.invoice && !loading.value)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t("secure_checkout")), 1),
                _createElementVNode("p", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t("qoute_reference")) + " ", 1),
                  _createElementVNode("strong", null, _toDisplayString(quote.value?.invoice?.quote_ref_no), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("img", {
                          src: `${domain.value}${url.value}/img/${quote.value?.invoice?.get_provider_detail?.image}`,
                          class: "img-fluid"
                        }, null, 8, _hoisted_12)
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("h5", _hoisted_15, [
                            _createTextVNode(_toDisplayString(quote.value?.invoice?.insurance_plan_name) + " - " + _toDisplayString(quote.value?.invoice?.insurance_coverage_name) + " ", 1),
                            (quote.value?.invoice?.insurance_cover_for != null && !showForGts.value)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(" - " + _toDisplayString(quote.value?.invoice?.insurance_cover_for), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _hoisted_18,
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, " (" + _toDisplayString(_ctx.$t("from")) + " " + _toDisplayString(_unref(setDateMdY)(quote.value.start_date)) + " " + _toDisplayString(_ctx.$t("to")) + " " + _toDisplayString(_unref(setDateMdY)(quote.value.end_date)) + ") ", 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _hoisted_22,
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["text", {'wrap-content' : _unref(getTextWidth)(quote.value.destination_country) > 150 ? true : false }])
                              }, [
                                _createTextVNode(_toDisplayString(_ctx.$t("destination_label_review_page")) + " : ", 1),
                                _createVNode(_component_el_tooltip, {
                                  class: "box-item",
                                  effect: "light",
                                  disabled: _unref(getTextWidth)(quote.value.destination_country) > 150 ? false : true
                                }, {
                                  content: _withCtx(() => [
                                    _createElementVNode("p", _hoisted_24, _toDisplayString(quote.value.destination_country), 1)
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(quote.value.destination_country), 1)
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ], 2)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quote.value?.invoice
                                ?.highlight, (highlight, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                              (highlight.section == 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                    _createElementVNode("p", null, [
                                      _createTextVNode(_toDisplayString(language.value === "ar"
                              ? highlight.label_ar
                              : highlight.label) + " ", 1),
                                      _createElementVNode("span", null, _toDisplayString(highlight && highlight.value ? highlight.value : '-'), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("p", null, _toDisplayString(_ctx.$t("total_premium")), 1),
                              _createElementVNode("div", {
                                class: _normalizeClass([quote.value.invoice?.premium_summary ? 'label-block ms-1 mt-2' : 'label-block'])
                              }, [
                                (quote.value.invoice?.premium_summary)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                      _createVNode(_component_el_tooltip, {
                                        class: "box-item",
                                        effect: "light"
                                      }, {
                                        content: _withCtx(() => [
                                          _createElementVNode("p", _hoisted_32, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quote.value.invoice?.premium_summary, (premiumPerson, index) => {
                                              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                                _createTextVNode(_toDisplayString(premiumPerson.label) + " : $" + _toDisplayString(premiumPerson.value), 1),
                                                _hoisted_33
                                              ], 64))
                                            }), 128))
                                          ])
                                        ]),
                                        default: _withCtx(() => [
                                          _hoisted_34
                                        ]),
                                        _: 1
                                      })
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 2)
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("h4", _hoisted_36, _toDisplayString(_ctx.currency.format(quote.value.invoice?.total_price_without_vat)), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.$t("no_of_traveller_placeholder")) + " : " + _toDisplayString(quote.value.no_of_traveller), 1)
                          ]),
                          (
                                agent.value != '' &&
                                agent.value != 'undefined' &&
                                agent.value != undefined
                              )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                _hoisted_40,
                                _createElementVNode("ul", _hoisted_41, [
                                  _createElementVNode("li", null, [
                                    _createElementVNode("div", _hoisted_42, [
                                      _createElementVNode("button", {
                                        onClick: _cache[0] || (_cache[0] = ($event: any) => (sentLinkToCustomer('whatsapp', 'checkout-detail')))
                                      }, _hoisted_44)
                                    ])
                                  ]),
                                  _createElementVNode("li", null, [
                                    _createElementVNode("div", {
                                      class: "icon",
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (sentLinkToCustomer('email', 'checkout-detail')))
                                    }, _hoisted_46)
                                  ])
                                ]),
                                (isSent.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, _hoisted_49))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quote.value?.invoice?.highlight, (highlight, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        (highlight.section == 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                              _createElementVNode("p", null, [
                                _createTextVNode(_toDisplayString(language.value === "ar"
                        ? highlight.label_ar
                        : highlight.label) + " ", 1),
                                _createElementVNode("span", null, _toDisplayString(highlight && highlight.value ? highlight.value : '-'), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    (
                      quote.value?.invoice?.highlight &&
                      quote.value?.invoice?.highlight.length
                    )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["result-listing__item__block-bottom", readMore.value ? 'open' : '']),
                          style: _normalizeStyle(`display: ${readMore.value ? 'block' : 'none'}`)
                        }, [
                          _createElementVNode("div", _hoisted_55, [
                            _createElementVNode("div", _hoisted_56, [
                              _createElementVNode("div", _hoisted_57, [
                                _createElementVNode("h4", _hoisted_58, _toDisplayString(_ctx.$t("full_summary")), 1)
                              ]),
                              _createVNode(_component_el_scrollbar, { height: "170px" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_59, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quote.value?.invoice
                                ?.highlight, (highlight, index) => {
                                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                        (highlight.section == 3)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                              _createElementVNode("div", _hoisted_61, [
                                                _createElementVNode("ul", null, [
                                                  _createElementVNode("li", _hoisted_62, [
                                                    _createTextVNode(_toDisplayString(language.value === "ar"
                                      ? highlight.label_ar
                                      : highlight.label) + " ", 1),
                                                    _createElementVNode("span", _hoisted_63, _toDisplayString(language.value === "ar"
                                        ? addDash(highlight.value_ar)
                                        : addDash(highlight.value)), 1)
                                                  ])
                                                ])
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    }), 128))
                                  ])
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ], 6))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (
                  quote.value?.invoice?.highlight && quote.value?.invoice?.highlight.length
                )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["btn", readMore.value ? 'active' : '']),
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (readMore.value = !readMore.value))
                      }, [
                        _createElementVNode("i", null, _toDisplayString(!readMore.value ? _ctx.$t("show_full_summary") : _ctx.$t("hide_full_summary")), 1),
                        _hoisted_65
                      ], 2)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, [
                    _hoisted_68,
                    (quote.value?.travellers_info)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quote.value?.travellers_info, (traveller, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "item",
                              key: index
                            }, [
                              _createElementVNode("h4", _hoisted_70, _toDisplayString(_ctx.$t("traveller_seq", { count: index + 1 })), 1),
                              traveller
                                ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                    _createElementVNode("div", _hoisted_72, [
                                      _createElementVNode("div", _hoisted_73, [
                                        _createElementVNode("h2", null, _toDisplayString(_ctx.$t("title")), 1),
                                        _createElementVNode("p", null, _toDisplayString(_ctx.dropDown.getPrefex(traveller.type)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_74, [
                                        _createElementVNode("h2", null, _toDisplayString(_ctx.$t("first_name")), 1),
                                        _createElementVNode("p", null, _toDisplayString(traveller.first_name), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_75, [
                                        _createElementVNode("h2", null, _toDisplayString(_ctx.$t("middle_name")), 1),
                                        _createElementVNode("p", null, _toDisplayString(traveller.middle_name ?? '-'), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_76, [
                                        _createElementVNode("h2", null, _toDisplayString(_ctx.$t("last_name")), 1),
                                        _createElementVNode("p", null, _toDisplayString(traveller.last_name), 1)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_77, [
                                      _createElementVNode("div", _hoisted_78, [
                                        _createElementVNode("h2", null, _toDisplayString(_ctx.$t("DOB")), 1),
                                        _createElementVNode("p", null, _toDisplayString(traveller.date_of_birth), 1)
                                      ]),
                                      (showForIsa.value || showForGts.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                            _createElementVNode("h2", null, _toDisplayString(_ctx.$t("gender")), 1),
                                            _createElementVNode("p", null, _toDisplayString(_ctx.dropDown.getGender(traveller.gender_id)), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (showForAll.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                            _createElementVNode("h2", null, _toDisplayString(_ctx.$t("country_of_residence")), 1),
                                            _createElementVNode("p", null, _toDisplayString(_ctx.dropDown.getNationality(traveller.country_id)), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (showForAll.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                            _createElementVNode("h2", null, _toDisplayString(_ctx.$t("nationality")), 1),
                                            _createElementVNode("p", null, _toDisplayString(_ctx.dropDown.getNationality(traveller.nationality_id)), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (showForAll.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                            _createElementVNode("h2", null, _toDisplayString(_ctx.$t("passport")), 1),
                                            _createElementVNode("p", null, _toDisplayString(traveller.passport), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (showForGts.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                                            _createElementVNode("h2", null, _toDisplayString(_ctx.$t("relationship")), 1),
                                            _createElementVNode("p", null, _toDisplayString(traveller.relationship_type_text), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_84, [
                    _createElementVNode("div", _hoisted_85, [
                      _createElementVNode("div", _hoisted_86, [
                        _createElementVNode("div", _hoisted_87, [
                          _createElementVNode("div", _hoisted_88, [
                            _createElementVNode("div", _hoisted_89, [
                              _createElementVNode("div", _hoisted_90, [
                                _createElementVNode("div", _hoisted_91, [
                                  _createElementVNode("h3", null, _toDisplayString(_ctx.$t('coupons')), 1),
                                  _createElementVNode("div", _hoisted_92, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      placeholder: _ctx.$t('coupon_ph'),
                                      class: "inputfield",
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((coupon).value = $event)),
                                      onInput: trimSpaces
                                    }, null, 40, _hoisted_93), [
                                      [_vModelText, coupon.value]
                                    ]),
                                    (!couponSuccess.value)
                                      ? (_openBlock(), _createElementBlock("input", {
                                          key: 0,
                                          type: "submit",
                                          onClick: _withModifiers(couponCode, ["prevent"]),
                                          value: _ctx.$t('apply'),
                                          class: "btn-outlined-blue no-border"
                                        }, null, 8, _hoisted_94))
                                      : (_openBlock(), _createElementBlock("input", {
                                          key: 1,
                                          type: "submit",
                                          onClick: _withModifiers(couponRemove, ["prevent"]),
                                          value: _ctx.$t('remove'),
                                          class: "btn-outlined-red no-border ash-text-color"
                                        }, null, 8, _hoisted_95))
                                  ]),
                                  (couponError.value)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_96, _toDisplayString(couponError.value), 1))
                                    : _createCommentVNode("", true),
                                  _withDirectives(_createElementVNode("span", { class: "success" }, _toDisplayString(_ctx.$t('coupon_applied')), 513), [
                                    [_vShow, couponSuccess.value]
                                  ])
                                ])
                              ]),
                              _createElementVNode("h3", null, _toDisplayString(_ctx.$t("disclaimer")), 1),
                              _createElementVNode("p", null, _toDisplayString(_ctx.$t("disclaimer_details")), 1)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_97, [
                        _createElementVNode("div", _hoisted_98, [
                          _createElementVNode("div", _hoisted_99, [
                            _createElementVNode("h5", _hoisted_100, _toDisplayString(_ctx.$t("summary")), 1),
                            _createElementVNode("div", {
                              class: _normalizeClass([quote.value?.invoice?.premium_summary ? 'label-block ms-1 mt-2' : 'label-block'])
                            }, [
                              (quote.value?.invoice?.premium_summary)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                    _createVNode(_component_el_tooltip, {
                                      class: "box-item",
                                      effect: "light"
                                    }, {
                                      content: _withCtx(() => [
                                        _createElementVNode("p", _hoisted_102, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quote.value?.invoice?.premium_summary, (premiumPerson, index) => {
                                            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                              _createTextVNode(_toDisplayString(premiumPerson.label) + " : $" + _toDisplayString(premiumPerson.value), 1),
                                              _hoisted_103
                                            ], 64))
                                          }), 128))
                                        ])
                                      ]),
                                      default: _withCtx(() => [
                                        _hoisted_104
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2)
                          ]),
                          _createElementVNode("div", _hoisted_105, [
                            _createElementVNode("div", _hoisted_106, [
                              _createElementVNode("div", _hoisted_107, [
                                _createElementVNode("div", _hoisted_108, _toDisplayString(_ctx.$t("premium")), 1),
                                _createElementVNode("div", _hoisted_109, _toDisplayString(_ctx.currency.format(
                                quote.value?.invoice?.insurance_plan_price,
                                2
                                )), 1)
                              ]),
                              (quote.value?.invoice?.policy_addons && quote.value?.invoice?.policy_addons.length > 0)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(quote.value?.invoice?.policy_addons, (addon, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "summary-block__table--item",
                                      key: index
                                    }, [
                                      _createElementVNode("div", _hoisted_110, _toDisplayString(addon.addon_name), 1),
                                      _createElementVNode("div", _hoisted_111, _toDisplayString(_ctx.currency.format(addon.addon_price)), 1)
                                    ]))
                                  }), 128))
                                : _createCommentVNode("", true),
                              (vat.value > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                                    _createElementVNode("div", _hoisted_113, _toDisplayString(_ctx.$t("vat_t", { vat: vatper.value })), 1),
                                    _createElementVNode("div", _hoisted_114, _toDisplayString(_ctx.currency.format(vat.value || 0, 2)), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (stampFee.value > 0 && showForGts.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                                    _createElementVNode("div", _hoisted_116, _toDisplayString(_ctx.$t("stamp_fee")), 1),
                                    _createElementVNode("div", _hoisted_117, _toDisplayString(_ctx.currency.format(stampFee.value || 0, 2)), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (discount.value > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                                    _createElementVNode("div", _hoisted_119, _toDisplayString(_ctx.$t('discount')), 1),
                                    _createElementVNode("div", _hoisted_120, _toDisplayString(_ctx.currency.format(discount.value || 0, 2)), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_121, [
                                _createElementVNode("div", _hoisted_122, _toDisplayString(_ctx.$t("payable_amount")), 1),
                                _createElementVNode("div", _hoisted_123, _toDisplayString(_ctx.currency.format(totalPremium.value, 2)), 1)
                              ])
                            ]),
                            (
                              agent.value == '' || agent.value == null || agent.value == undefined
                            )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                                  _createElementVNode("div", _hoisted_125, [
                                    _withDirectives(_createElementVNode("input", {
                                      class: "styled-checkbox",
                                      id: "add-to-compare1",
                                      type: "checkbox",
                                      value: "value1",
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isAccept).value = $event))
                                    }, null, 512), [
                                      [_vModelCheckbox, isAccept.value]
                                    ]),
                                    _createElementVNode("label", _hoisted_126, [
                                      _createElementVNode("span", null, [
                                        _createTextVNode(_toDisplayString(_ctx.$t("agree")) + " ", 1),
                                        _createElementVNode("a", _hoisted_127, _toDisplayString(_ctx.$t("tac")), 1)
                                      ])
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (
                              agent.value == '' || agent.value == null || agent.value == undefined
                            )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    disabled: !isAccept.value || loading.value,
                                    class: "btn btn-checkout",
                                    onClick: _cache[5] || (_cache[5] = ($event: any) => (proceedClick()))
                                  }, [
                                    _createElementVNode("span", _hoisted_130, _toDisplayString(_ctx.$t("proceed")), 1)
                                  ], 8, _hoisted_129)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createElementVNode("section", _hoisted_131, [
          _createElementVNode("div", _hoisted_132, [
            _createElementVNode("div", _hoisted_133, [
              _createElementVNode("div", _hoisted_134, [
                _createElementVNode("div", _hoisted_135, [
                  _createElementVNode("div", _hoisted_136, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('wait')), 1)
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createVNode(_component_h_page_loader)
      ], 64))
}
}

})